module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"files":"1 file in this case notes | {n} files in this case notes"}}')
  delete Component.options._Ctor
}
